<template>
  <div class="m19-cm">
    <div class="m19-cm__head text-body2 text-grey-8 q-mb-md">
      Документ М19 №<strong>{{ documentId }}</strong>
    </div>

    <q-banner v-if="!lines.length" rounded class="bg-grey-2 text-grey-7">
      Нет строк материалов для этого документа.
    </q-banner>

    <q-markup-table v-else flat bordered dense class="m19-cm__table">
      <thead>
        <tr>
          <th class="text-left">Материал</th>
          <th class="text-right">Списано</th>
          <th class="text-left">Комментарий к строке</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, idx) in lines" :key="idx">
          <td class="text-left">{{ row.material_name || '—' }}</td>
          <td class="text-right text-weight-medium">{{ formatQty(row.fact_qty) }}</td>
          <td class="text-left m19-cm__comments">{{ row.comments || '—' }}</td>
        </tr>
      </tbody>
    </q-markup-table>
  </div>
</template>

<script>
export default {
  name: "M19CommentMaterialsModal",

  props: {
    documentId: {
      type: [Number, String],
      default: null,
    },
    materials: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    lines() {
      const m = this.materials;
      if (!m || !Array.isArray(m)) return [];
      return m.filter((x) => x && (x.material_name != null || x.fact_qty != null || x.comments));
    },
  },

  methods: {
    formatQty(v) {
      if (v == null || v === "") return "—";
      const n = Number(v);
      if (!Number.isFinite(n)) return String(v);
      return n.toLocaleString("ru-RU", { maximumFractionDigits: 4 });
    },
  },
};
</script>

<style lang="scss" scoped>
.m19-cm {
  width: 100%;
  min-width: 0;
  max-width: none;

  &__head {
    font-size: 14px;
  }

  &__table {
    font-size: 14px;
    width: 100%;

    :deep(th),
    :deep(td) {
      padding: 10px 14px;
    }

    :deep(th) {
      font-weight: 600;
      font-size: 13px;
    }
  }

  &__comments {
    white-space: pre-wrap;
    word-break: break-word;
    min-width: 320px;
    max-width: none;
  }
}
</style>
